var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-empty"},[_c('img',{attrs:{"src":require("../../assets/images/img_empty.png")}}),_c('div',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }